import { create } from 'zustand';
import { ApiSecret } from '../../../types/ApiSecret';
import { ResponseData } from '../../../types/response/ResponseData';
import ResponseError from '../../../types/response/ResponseError';

export interface ApiSecretsStore {
    isSearching: boolean;
    isLoaded: boolean;
    searchResults: ResponseData<ApiSecret[]>;
    isCreated?: CreatedApiSecret;
    isCreating: boolean;
    createdError?: ResponseError;
    isRemoving: boolean;
    removeError?: ResponseError;
    searchError?: ResponseError;
    isRemoved: boolean;
    searchStarted: () => void;
    searchSucceeded: (data: ResponseData<ApiSecret[]>) => void;
    searchFailed: (error: ResponseError) => void;
    creating: () => void;
    created: (data: Record<string, string>) => void;
    creatingFailed: (error: ResponseError) => void;
    createdCleared: () => void;
    removing: () => void;
    removed: () => void;
    removeFailed: (error: ResponseError) => void;
    removedCleared: () => void;
    reset: () => void;
}

export interface CreatedApiSecret {
    clientId: string;
    apiSecret: string;
}

const initialState = {
    isSearching: false,
    isLoaded: false,
    isCreating: false,
    searchResults: {} as ResponseData<ApiSecret[]>,
    isCreated: undefined,
    createdError: undefined,
    isRemoving: false,
    removeError: undefined,
    isRemoved: false,
    searchError: undefined,
};

export const useApiSecretsStore = create<ApiSecretsStore>(set => ({
    ...initialState,

    searchStarted: () =>
        set({
            isSearching: true,
        }),

    searchSucceeded: (data: ResponseData<ApiSecret[]>) =>
        set({
            isSearching: false,
            isLoaded: true,
            searchResults: data,
        }),

    searchFailed: (error: ResponseError) =>
        set({
            isSearching: false,
            searchError: error,
        }),

    creating: () =>
        set({
            isCreating: true,
        }),

    created: (data: Record<string, string>) =>
        set({
            isCreated: { clientId: data.clientId, apiSecret: data.apiSecret },
            isCreating: false,
        }),

    creatingFailed: (error: ResponseError) =>
        set({
            isCreating: false,
            createdError: error,
        }),

    createdCleared: () =>
        set({
            isCreated: undefined,
            isCreating: false,
            createdError: undefined,
        }),

    removing: () =>
        set({
            isRemoving: true,
            isRemoved: false,
        }),

    removed: () =>
        set({
            isRemoving: false,
            isRemoved: true,
        }),

    removeFailed: (error: ResponseError) =>
        set({
            isRemoving: false,
            isRemoved: false,
            removeError: error,
        }),

    removedCleared: () =>
        set({
            isRemoving: false,
            isRemoved: false,
            removeError: undefined,
        }),

    reset: () => set(initialState),
}));

